import type { PublicSlotKey } from '@/apilib';
import type { EditorPaasApi } from './editorPaasApi';

export const EditorPaasApiKey: PublicSlotKey<EditorPaasApi> = {
  name: 'EditorPaasApi',
  public: true,
};
